/* global define, google, window */

define('views/MapView',[
	'jquery',
	'underscore',
	'backbone',
	'text!templates/views/Map.html'
], function($, _, Backbone, template) {

	'use strict';

	var View = Backbone.View.extend({
		events: {
		},
		initialize: function() {

			// Bind All
			_.bindAll(this);

			this.$window = $(window);

		},
		reset: function() {
		},
		getMap: function() {
			return this.map;
		},
		fitBounds: function(bounds){
			this.map.fitBounds(bounds);
		},
		getZoom: function(){
			return this.map.getZoom();
		},
		setZoom: function(zoom){
			this.map.setZoom(zoom);
		},
		setMinZoom: function(zoom){
			this.map.setOptions({
				minZoom:zoom
			});
		},
		render: function() {

			this.$el.html(template);
			this.$mapCanvas = this.$el.find('#map_canvas');

			var options = this.options.gmapsearch,
				_this = this;
				
			this.mapOptions = {
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				center: new google.maps.LatLng(options.center_lat, options.center_lng),
				zoom: options.map_zoom,
				scrollwheel: false,
				maxZoom: options.max_zoom,
				minZoom: options.min_zoom,
				disableDefaultUI: true,
				streetViewControl: true,
				zoomControl: true,
				disableDoubleClickZoom: false,
				zoomControlOptions: {
					style: google.maps.ZoomControlStyle.Rm,
					position: google.maps.ControlPosition.TOP_LEFT
				},
				mapTypeControl: true,
				mapTypeControlOptions: {
					/*style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,*/
					position: google.maps.ControlPosition.TOP_LEFT,
					mapTypeIds: [
						google.maps.MapTypeId.ROADMAP,
						google.maps.MapTypeId.SATELLITE,
						google.maps.MapTypeId.HYBRID,
						'terrain',
						'bicycling',
						'traffic'/*,
						'transit'*/
					]
				}
			};

			this.map = new google.maps.Map(this.$mapCanvas.get(0), this.mapOptions);

			var transitMapType = new google.maps.StyledMapType();
			transitMapType.name = 'Transit (US)';
			transitMapType.alt = 'Transit (US)';

			var bicyclingMapType = new google.maps.StyledMapType();
			bicyclingMapType.name = 'Bicycling';
			bicyclingMapType.alt = 'Bicycling';

			var trafficMapType = new google.maps.StyledMapType();
			trafficMapType.name = 'Traffic';
			trafficMapType.alt = 'Traffic';

			this.map.mapTypes.set('transit', transitMapType);
			this.map.mapTypes.set('bicycling', bicyclingMapType);
			this.map.mapTypes.set('traffic', trafficMapType);

			google.maps.event.addListener(this.map, 'maptypeid_changed', function(){

				if(_this.layer){
					_this.layer.setMap(null);
					_this.layer = null;
				}

				if(_this.map.getMapTypeId() === 'transit'){
					_this.layer = new google.maps.TransitLayer();
				}
				else if(_this.map.getMapTypeId() === 'bicycling'){
					_this.layer = new google.maps.BicyclingLayer();
				}
				else if(_this.map.getMapTypeId() === 'traffic'){
					_this.layer = new google.maps.TrafficLayer();
				}

				if(_this.layer){
					_this.layer.setMap(_this.map);
				}

			});

			// Listeners
			google.maps.event.addListener(this.map, 'drag', this.onDrag);
			google.maps.event.addListener(this.map, 'bounds_changed', this.onBoundsChanged);
			google.maps.event.addListener(this.map, 'zoom_changed', this.triggerUpdate);
			google.maps.event.addListener(this.map, 'idle', function(){
				_this.trigger('idle', this);
			});

			return this;
		},
		hideZoomControls: function() {

			this.map.setOptions({
				mapTypeControlOptions: false,
				zoomControl: false
			});
		},
		showZoomControls: function() {

			this.map.setOptions({
				mapTypeControl: true,
				zoomControl: true
			});

		},
		setStrictBounds: function(bounds) {
			this.strictBounds = bounds;
		},
		onBoundsChanged: function(){

			this.triggerUpdate();
			this.trigger('bounds-changed', this.map);
		},
		onDrag: function() {

			if (!this.strictBounds) {

				var options = this.options;

				// Set the Strict Bounds
				if (options.map_boundary_sw && options.map_boundary_ne && options.map_boundary_sw.length === 2 && options.map_boundary_ne.length === 2) {
					this.strictBounds = new google.maps.LatLngBounds(
					new google.maps.LatLng(options.map_boundary_sw[0], options.map_boundary_sw[1]),
					new google.maps.LatLng(options.map_boundary_ne[0], options.map_boundary_ne[1]));
				}
			}

			this.triggerUpdate();

			if (!this.strictBounds || this.strictBounds.contains(this.map.getCenter())) { return; }

			var strictBounds = this.strictBounds,
				map = this.map;

			var c = map.getCenter(),
				x = c.lng(),
				y = c.lat(),
				maxX = strictBounds.getNorthEast().lng(),
				maxY = strictBounds.getNorthEast().lat(),
				minX = strictBounds.getSouthWest().lng(),
				minY = strictBounds.getSouthWest().lat();

			if (x < minX) { x = minX; }
			if (x > maxX) { x = maxX; }
			if (y < minY) { y = minY; }
			if (y > maxY) { y = maxY; }

			map.setCenter(new google.maps.LatLng(y, x));

		},
		triggerUpdate: function(){

			var map = this.map,
				center = map.getCenter(),
				bounds = map.getBounds(),
				southWest = bounds.getSouthWest(),
				northEast = bounds.getNorthEast();

			this.trigger('change', 'map_zoom', map.getZoom());
			this.trigger('change', 'center_lat', center.lat());
			this.trigger('change', 'center_lng', center.lng());
			this.trigger('change', 'sw_lat', southWest.lat());
			this.trigger('change', 'sw_lng', southWest.lng());
			this.trigger('change', 'ne_lat', northEast.lat());
			this.trigger('change', 'ne_lng', northEast.lng());

		}

	});

	return View;
});
